@if (slides.length > 0) {
  <div class="simple-image-slider" [attr.data-theme]="theme" [attr.data-size]="size"
    [ngStyle]="{ height: height, borderRadius: borderRadius, overflow: 'hidden' }" aria-live="polite">
    <!-- Main Swiper Container -->
    <swiper-container
      #swiper
      class="swiper-main-container"
      slides-per-view="1"
      space-between="0"
      centered-slides="true"
      grab-cursor="true"
      speed="500"
      effect="slide">
      <!-- Slides -->
      @for (slide of slides; track slide; let i = $index) {
        <swiper-slide class="swiper-slide-item">
          <div class="slide-content">
            <div class="slide-link" (click)="goToLink(slide, $event)">
              <!-- appCachedImage direktifi ekleyelim -->
              <img appCachedImage
                [src]="slide.IMAGE"
                [alt]="slide.ALT || slide.TITLE || 'Slide ' + (i + 1)"
                class="slide-image"
                loading="lazy" />
                <!-- Simple title overlay -->
                @if (showOverlay && slide.TITLE) {
                  <div class="slide-title-overlay">
                    <h3>{{ slide.TITLE }}</h3>
                  </div>
                }
              </div>
            </div>
          </swiper-slide>
        }
      </swiper-container>
    </div>
  }